import { QUERY_PARAM } from "../../utils/config";

export function getExtraQueryparam() {
    const val = localStorage.getItem(QUERY_PARAM);
    if (val === null) {
        return '';
    }
    const valStr = val.toString();
    const cleanedVal = '&' + valStr.replace(/^"(.*)"$/, '$1');
    return cleanedVal;
}

export async function getDeviceID(): Promise<string> {
    const sha256 = async (input: string): Promise<string> => {
        const encoder = new TextEncoder();
        const data = encoder.encode(input);
        const hashBuffer = await crypto.subtle.digest("SHA-256", data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
    };

    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    const language = navigator.language;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    const screenRes = `${screen.width}x${screen.height}`;
    const colorDepth = screen.colorDepth.toString();

    const getCanvasFingerprint = (): string => {
        try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) return "unsupported";
            ctx.textBaseline = "top";
            ctx.font = "14px 'Arial'";
            ctx.textBaseline = "alphabetic";
            ctx.fillStyle = "#f60";
            ctx.fillRect(125, 1, 62, 20);
            ctx.fillStyle = "#069";
            ctx.fillText("C@nvas_fingerprint!", 2, 15);
            ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
            ctx.fillText("C@nvas_fingerprint!", 4, 17);
            return canvas.toDataURL();
        } catch {
            return "unsupported";
        }
    };

    const getWebGLFingerprint = (): string => {
        try {
            const canvas = document.createElement("canvas");
            const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
            if (!gl) return "unsupported";
            const glContext = gl as WebGLRenderingContext;
            const debugInfo = glContext.getExtension("WEBGL_debug_renderer_info");
            const vendor = debugInfo ? glContext.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) : "unknown";
            const renderer = debugInfo ? glContext.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : "unknown";
            return `${vendor}~${renderer}`;
        } catch {
            return "unsupported";
        }
    };

    const getAudioFingerprint = async (): Promise<string> => {
        try {
            const AudioContextClass = window.OfflineAudioContext || (window as any).webkitOfflineAudioContext;
            const audioCtx = new AudioContextClass(1, 44100, 44100);
            const oscillator = audioCtx.createOscillator();
            oscillator.type = "triangle";
            oscillator.frequency.setValueAtTime(10000, audioCtx.currentTime);
            const compressor = audioCtx.createDynamicsCompressor();
            oscillator.connect(compressor);
            compressor.connect(audioCtx.destination);
            oscillator.start(0);
            const buffer = await audioCtx.startRendering();
            let fingerprint = 0;
            const data = buffer.getChannelData(0);
            for (let i = 0; i < data.length; i++) {
                fingerprint += Math.abs(data[i]);
            }
            return fingerprint.toString();
        } catch {
            return "unsupported";
        }
    };

    const canvasFP = getCanvasFingerprint();
    const webglFP = getWebGLFingerprint();
    const audioFP = await getAudioFingerprint();

    const combined = [
        userAgent,
        platform,
        language,
        timezone,
        screenRes,
        colorDepth,
        canvasFP,
        webglFP,
        audioFP
    ].join("||");

    return await sha256(combined);
}

export function scopeParse(scope: string, scopeString: string) {
    var permission;

    switch (scope) {
        case "profile.read":
            permission = "Read profile details"
            break;
        case "orders.read":
            if (scopeString.indexOf("orders.write") !== -1) {
                break;
            }
            permission = ""
            break
        case "orders.write":
            permission = "Place & manage orders"
            break;
        case "holdings.read":
            permission = "Fetch holdings"
            break;
        default:
            permission = ""
            break;
    }
    return permission
}